import dayjs from 'dayjs'
import { eventsApi } from '~/shared/api'
import {
  EventLoggerInstanceName,
  PlatformOS,
} from '~/shared/constants/commonConstants'
import { getMobileOperatingSystem } from '~/shared/helpers/getMobileOperatingSystem'
import { Events } from '~/shared/services/eventLogger'
import { IEventLogger } from '~/shared/types/eventsTypes'

export class UserFlowTracker implements IEventLogger {
  public readonly name: EventLoggerInstanceName
  private readonly userId: string
  private cohort = ''
  private deviceType: PlatformOS = PlatformOS.UNKNOWN

  constructor({
    userId,
    instanceName,
  }: {
    userId: string
    instanceName: EventLoggerInstanceName
  }) {
    this.userId = userId
    this.name = instanceName
  }

  configure({ cohort }: { cohort: string }): void {
    this.cohort = cohort
    this.deviceType = getMobileOperatingSystem()
  }

  log(
    event: Events,
    eventProperty?: Record<string, unknown>,
    cb?: () => void,
  ): void {
    const timestampInSec = dayjs().unix()

    const mergedEventProperty = {
      cohort: this.cohort,
      user_id: this.userId,
      device_type: this.deviceType,
      timestamp: timestampInSec,
      ...eventProperty,
    }

    eventsApi.sendEvent(event, mergedEventProperty, cb)
  }
}
